import { PublishedEventListItem, TopMarketTypeDisplay } from '../../@types';
import useLocalization from '../../hooks/useLocalization';
import Heading from '../atoms/Heading';
import Carousel from '../organisms/Carousel';
import EventCard from './EventCard';

export type EventsCarouselProps = {
  title: string;
  events: PublishedEventListItem[];
  topMarketTypes?: TopMarketTypeDisplay[];
  link?: string;
};

const EventsCarousel = ({ title, events, topMarketTypes, link }: EventsCarouselProps) => {
  const { t } = useLocalization();

  return (
    <>
      <Heading to={link}>
        <Heading.Title>{title}</Heading.Title>
        {link && <Heading.Link>{t('goToMatches')}</Heading.Link>}
      </Heading>
      <Carousel>
        {events.map((event) => (
          <EventCard key={event.id} event={event} topMarketTypes={topMarketTypes} />
        ))}
      </Carousel>
    </>
  );
};

export default EventsCarousel;
